import { render, staticRenderFns } from "./PagesEconomistReportComponent.vue?vue&type=template&id=65543b17&scoped=true"
import script from "./PagesEconomistReportComponent.vue?vue&type=script&lang=js"
export * from "./PagesEconomistReportComponent.vue?vue&type=script&lang=js"
import style0 from "./PagesEconomistReportComponent.vue?vue&type=style&index=0&id=65543b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65543b17",
  null
  
)

export default component.exports